// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"153":"fdc0945f","260":"14656d6f","668":"7f60f21c","762":"240b1e52"}[chunkId] + ".js";
};